import API from '@/service/api'

const state = {
  offerEntries: [],
  offerEntry: {},
}

const mutations = {
  UPDATE_OFFER_ENTRIES(state, payload) {
    state.offerEntries = payload
  },
  UPDATE_OFFER_ENTRY(state, payload) {
    state.offerEntry = payload
  },
}

const actions = {
  getOfferEntries({ commit }) {
    return API()
      .get('/offers')
      .then(response => {
        console.log('getOfferEntries OK')
        commit('UPDATE_OFFER_ENTRIES', response.data)
      })
      .catch(error => {
        console.log('Error: getOfferEntries')
        console.log(error)
        return error
      })
  },
  addOffer({ commit }, payload) {
    return API()
      .post('/offers', payload)
      .then(response => {
        commit('UPDATE_OFFER_ENTRY', response.data)
        return response.data
      })
      .catch(error => {
        console.log('Error: addOffer')
        console.log(error)
        return error
      })
  },
  deleteOffer({ commit }, id) {
    API()
      .delete(`/offers/${id}`)
      .then(response => {
        commit('UPDATE_OFFER_ENTRIES', response.data).catch(error => {
          console.error(error)
        })
      })
  },
  updateOffer({ commit, dispatch }, payload) {
    return API()
      .put(`/offers/${payload.id}`, payload)
      .then(response => {
        commit('UPDATE_OFFER_ENTRY', response.data)
        // Refresh the offers list to ensure consistency
        dispatch('getOfferEntries')
        return response.data
      })
      .catch(error => {
        console.error(error)
        throw error
      })
  },
}

const getters = {
  offerEntries: state => state.offerEntries,

  offerByID: state => id =>
    state.offerEntries.find(offerEntry => offerEntry.id === id),

  // Get total sum of all storages within all offers
  getTotalSumOfAllStoragesAndOffers: state => {
    let sum = 0
    for (let index = 0; index < state.offerEntries.length; index += 1) {
      if (state.offerEntries[index].isActive) {
        for (
          let index2 = 0;
          index2 < state.offerEntries[index].storages.length;
          index2 += 1
        ) {
          sum += state.offerEntries[index].storages[index2].price
        }
      }
    }
    return sum
  },

  // Get offers where isActive is true
  getActiveOffers: state =>
    state.offerEntries.filter(offerEntry => offerEntry.isActive),

  // Get offers by customer ID
  offersByCustomerId: state => customerId =>
    state.offerEntries.filter(offer =>
      offer.customer === customerId || offer.customer?.id === customerId),
}

const orderModule = {
  state,
  mutations,
  actions,
  getters,
}

export default orderModule
